<central-login-header [platform]="currentPlatform"></central-login-header>

<div class="content" *ngIf="currentPlatform">
    <h3 class="form-title">{{'central-login.join.platform' | translate: { 'platform' : currentPlatform.club.name } }}</h3>

    <div class="alert alert-info" *ngIf="userJoined">
        {{'central-login.join.success' | translate : { 'club' : currentPlatform.club.name}  }}
    </div>

    <form [formGroup]="joinForm" (ngSubmit)="join()" *ngIf="!userJoined">
        <div class="alert alert-danger" *ngIf="joinError">
            {{'central-login.join.error' | translate  }}
        </div>

        <span class="text-white mb-3 d-inline-block">{{ userEmail }}</span>

        <div class="alert alert-danger" *ngIf="(userAccountInactive && !activationMailSent) || badCredentials ">
            {{emailErrorMessage | translate}}
        </div>

        <div class="alert alert-info" *ngIf="activationMailSent">
            {{'central-login.join.activation.mail.sent' | translate : { 'club' : currentPlatform.club.name}  }}
        </div>

        <div class="form-group"  *ngIf="!userAccountInactive">
            <label class="form-control-label">{{'central-login.password' | translate }}</label>
                <input type="password" id="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && form.password.errors }" />
                <div *ngIf="submitted && form.password.errors" >
                    <div class="alert alert-danger mt-3 mb-0 p-2" *ngIf="form.password.errors.required">{{ 'central-login.password.required' | translate }}</div>
                    <div class="alert alert-danger mt-3 mb-0 p-2" *ngIf="form.password.errors.minlength">{{ 'central-login.password.error.min.length' | translate }}</div>
                    <div class="alert alert-danger mt-3 mb-0 p-2" *ngIf="form.password.errors.passwordStrength">{{ 'central-login.password.error.strength' | translate }}</div>
                </div>
        </div>

        <div class="row login-form__actions" *ngIf="!userAccountInactive">
            <div class="col-md-12 text-left">
                <p><a [routerLink]="'/central-login/forgot-password'" class="signup"><i class="fa fa-question-circle-o"></i> {{'central-login.password.lost' | translate }}</a></p>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-md-12">
                <button class="btn psd-variant w-100" type="submit" [disabled]="submitting || userAccountInactive" >{{'central-login.join' | translate }}</button>
            </div>
        </div>

        <div class="row mt-3 text-center text-white">
            <div class="col-md-12">
                {{'central-login.or' | translate }}
            </div>
        </div>

        <div class="row mt-3 mb-5">
            <div class="col-md-12">
                <button class="btn default w-100" (click)="goToLogin()" >{{'central-login.login.other.account' | translate }}</button>
            </div>
        </div>
    </form>
</div>
<central-login-footer></central-login-footer>
<central-login-background-slider [platform]="currentPlatform" ></central-login-background-slider>
<form id="goToPlatformForm" action="" method="post">
    <input type="hidden" name="central_access_token" value="">
    <input type="hidden" name="central_refresh_token" value="">
    <input type="hidden" name="refresh_token" value="">
    <input type="hidden" name="access_token" value="">
    <input type="hidden" name="expires_in" value="">
    <input type="hidden" name="force_token_refresh" value="false">
</form>
